import {Breadcrumb} from './breadcrumb';

export class BreadcrumbConfig {
  static HOME: Breadcrumb = {name: 'Home', route: '/'};
  static TOPICS: Breadcrumb = {name: 'Topics', route: '/topics'};
  static LOCATIONS: Breadcrumb = {name: 'Locations', route: '/locations'};
  static HEALTHSTATS_PLUS: Breadcrumb = {name: 'HealthStats PLUS', route: '/healthstatsplus'};
}
